import z from 'zod'

import { zh } from '@/libs/utils/zod'

export const ItemCategoryDto = z.object({
  name: z.string(),
  desc: z.string(),
  isActive: z.boolean(),
  ...zh.metadata.shape,
})

export type ItemCategoryDto = z.infer<typeof ItemCategoryDto>
